import "./SpaghettiMenu.css";
import React, { useRef, useEffect, useState } from "react";
import { useIsVisible } from "../Menu";
import axios from "axios";
import SpaghettiItem from "./SpaghettiItem";

export default function SpaghettiMenu() {
  const ref = useRef();
  const isVisible = useIsVisible(ref);

  const [spaghettis, setSpaghettis] = useState([]);
  const requesturlapi = async () => {
    if (spaghettis.length === 0) {
      try {
        await axios
          .get(process.env.REACT_APP_BACKEND + process.env.REACT_APP_SPAGHETTIS)
          .then((response) => {
            setSpaghettis(response.data);
          });
      } catch {
        console.error("Failed to fetch freshfood menu");
      }
    }
  };

  useEffect(() => {
    requesturlapi();
  });

  useEffect(() => {
    const element = document.getElementById("spaghettiButton");
    const navButtons = document.getElementsByClassName("navButton");
    if (element) {
      if (isVisible) {
        if (navButtons) {
          var bIsAloneActive = true;
          for (let navButton of navButtons) {
            if (
              navButton.classList.contains("aloneActive") &&
              navButton !== element
            ) {
              bIsAloneActive = false;
              break;
            }
          }
          if (bIsAloneActive) {
            element.classList.add("aloneActive");
          } else {
            element.classList.add("almostActive");
          }
        }
      } else {
        if (navButtons) {
          element.classList.remove("almostActive");
          for (let navButton of navButtons) {
            if (navButton.classList.contains("almostActive")) {
              navButton.classList.add("aloneActive");
              navButton.classList.remove("almostActive");
            }
          }
        }
        element.classList.remove("aloneActive");
      }
    }
  }, [isVisible]);

  return (
    <div ref={ref} className="freshFoodMenu">
      {spaghettis.map((spaghetti, index) => (
        <SpaghettiItem
          key={index}
          name={spaghetti.name}
          price={spaghetti.price}
          imgSource={spaghetti.image}
          extras={spaghetti.extras ?? []}
        ></SpaghettiItem>
      ))}
    </div>
  );
}
